import axios from 'axios';

const getIpAddress = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json');
    return response.data.ip;
  } catch (error) {
    console.error('Error fetching IP address:', error);
    throw new Error('Could not fetch IP address.');
  }
};

export const ipService = {
    getIpAddress,
};